import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, isInvalid } from 'redux-form'
import { Button } from 'react-bootstrap'

import * as actions from '../../../actions'
import PrinterPicker from
  '../../../../Printer/containers/PrinterPicker'
import CamposReimpresionComprobante0 from
  '../../../components/reimpresionComprobante/CamposReimpresionComprobante0'
import { FORM_REIMPRESION_COMPROBANTE } from '../../../../../config/forms'

class ReimpresionComprobante0 extends Component {
  constructor (props) {
    super(props)
    this.selectPrinter = this.selectPrinter.bind(this)
    this.onPrinterChange = this.onPrinterChange.bind(this)
  }

  selectPrinter (printer, printerName) {
    this.props.selectPrinter(printer, printerName)
  }

  onPrinterChange () {
    this.props.resetPrinter()
  }

  handleInputChange (e) {
    if (!isNaN(e.target.value)) {
      this.props.completoupdateCpa(e.target.value)
    }
    if ((String(e.target.value).length === 12)) {
      this.props.completoupdateCpa(e.target.value)
      process.nextTick(this.props.onSubmit)
    }
  }

  render () {
    const {
      handleSubmit,
      iCompletoImpresora,
      iCompletoImpresoraNombre,
      iCompletoCpaTextValue,
      invalid
    } = this.props

    return (
      <div className='completo_busqueda_cpa'>
        <form onSubmit={handleSubmit}>
          <PrinterPicker
            onSubmit={this.selectPrinter}
            place='icompleto'
            name='printerICompleto'
            show={iCompletoImpresora == null} />
          <CamposReimpresionComprobante0
            onPrinterChange={this.onPrinterChange}
            printerName={iCompletoImpresoraNombre}
            cpaTextValue={iCompletoCpaTextValue}
            onChange={this.handleInputChange.bind(this)}
          />
          <br />
          <Button
            type='submit'
            variant='primary'
            size='lg'
            disabled={invalid}
          >Siguiente
          </Button>
        </form>
      </div>
    )
  };
};

const mapStateToProps = (state) => ({
  iCompletoImpresora: state.camionesIngreso.iCompletoImpresora,
  iCompletoImpresoraNombre: state.camionesIngreso.iCompletoImpresoraNombre,
  invalid: isInvalid(FORM_REIMPRESION_COMPROBANTE)(state),
  iCompletoCpaTextValue: state.camionesIngreso.iCompletoCpaTextValue
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_REIMPRESION_COMPROBANTE,
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})

export default withRedux(withReduxForm(ReimpresionComprobante0))
